import { HibooIcon, Link, NavigationLink } from 'modules/design-system';
import { useTheme } from 'styled-components';

import { AuthBaseCardFooterCSS } from './AuthBaseCardFooter.css';

const { Container, HibooIconWrapper, LinkWrapper } = AuthBaseCardFooterCSS;

type LinkConfig = {
  to: string;
  label: string;
};

type NavigationLinkConfig = {
  to: string;
  label: string;
};

type Props = {
  link: LinkConfig;
  navigationLink?: NavigationLinkConfig;
};

export const AuthBaseCardFooter = ({ link, navigationLink }: Props) => {
  const theme = useTheme();

  return (
    <Container>
      <LinkWrapper>
        <Link to={link.to}>{link.label}</Link>
      </LinkWrapper>

      {navigationLink && (
        <NavigationLink
          to={navigationLink.to}
          target="_blank"
          iconLeft={
            <HibooIconWrapper>
              <HibooIcon small color={theme.colors.text.subtle} />
            </HibooIconWrapper>
          }
        >
          {navigationLink.label}
        </NavigationLink>
      )}
    </Container>
  );
};
